export default __webpack_public_path__ + "static/media/shop_product_update.9ec238b8.csv";